import { useAxios } from '@/app/composable';
import { RunnerAPI } from '../api';
import { has, is, isNil } from 'ramda';
import { computed, ref, Ref, watch } from '@vue/composition-api';
import path from 'path';

export function useRunnerPath(id: Ref<string | undefined>) {
    const { exec } = useAxios(true);

    const basePath = ref<string | undefined>();

    const uploadsPath = computed(() => `${buildPath('/uploads/')}`);

    const basePathWidthInPx = computed((): number => {
        if (!isNil(basePath.value)) return basePath.value.length * 6;

        return 0;
    });

    const uploadsPathWidthInPx = computed((): number => {
        if (!isNil(uploadsPath.value)) return uploadsPath.value.length * 6;

        return 0;
    });

    const fetch = async (runnerId: string): Promise<string> => {
        const response = await exec(RunnerAPI.getBasePath(runnerId));

        if (
            isNil(response) ||
            !has('data', response) ||
            isNil(response.data) ||
            isNil(response.data) ||
            !has('basePath', response.data) ||
            isNil(response.data.basePath) ||
            !is(String, response.data.basePath)
        )
            throw Error(`No base path for runner ${id.value}`);

        return `${response.data.basePath}`;
    };

    const buildPath = (relativePath: string = '', customBase?: string) => {
        if (isNil(customBase) && isNil(basePath.value)) return undefined;
        const prefix = customBase || basePath.value;
        return path.join(prefix || '', relativePath);
    };

    const getRelativePath = (fullPath: string | null = '', customBase?: string) => {
        if (isNil(fullPath)) return '';
        return fullPath.replace(`${customBase || basePath.value}`, '');
    };

    watch(
        () => id.value,
        async (newId: string | undefined) => {
            if (!isNil(newId) && is(String, newId)) basePath.value = await fetch(newId);
            else basePath.value = undefined;
        },
        { immediate: true },
    );

    return { basePath, uploadsPath, basePathWidthInPx, uploadsPathWidthInPx, buildPath, getRelativePath };
}
